(function() {
  document.addEventListener('change', function(e) {
    if (e.target.matches('[data-qty-select]')) {
      const wrapper = e.target.closest('[data-qty-wrapper]');
      if (!wrapper) return;

      const select = e.target;
      const customInput = wrapper.querySelector('[data-qty-input]');
      const originalInput = wrapper.querySelector('[data-quantity-input]');
      const selectContainer = wrapper.querySelector('[data-select-container]');
      const inputContainer = wrapper.querySelector('[data-input-container]');

      if (!customInput || !selectContainer || !inputContainer) return;

      if (select.value === '10+') {
        selectContainer.classList.add('hidden');
        inputContainer.classList.remove('hidden');
        customInput.value = 10;
        
        setTimeout(() => {
          customInput.focus();
          customInput.select();
        }, 10);
        
        if (originalInput) {
          originalInput.value = 10;
          originalInput.dispatchEvent(new Event('input', { bubbles: true }));
          originalInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
      } else {
        customInput.value = select.value;
        if (originalInput) {
          originalInput.value = select.value;
          originalInput.dispatchEvent(new Event('input', { bubbles: true }));
          originalInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    }

    if (e.target.matches('[data-qty-input]')) {
      const wrapper = e.target.closest('[data-qty-wrapper]');
      if (!wrapper) return;
      
      const customInput = e.target;
      const originalInput = wrapper.querySelector('[data-quantity-input]');
      const select = wrapper.querySelector('[data-qty-select]');
      const selectContainer = wrapper.querySelector('[data-select-container]');
      const inputContainer = wrapper.querySelector('[data-input-container]');

      if (!select || !selectContainer || !inputContainer) return;
      
      let val = parseInt(customInput.value, 10);
      if (val < 1 || isNaN(val)) {
        val = 1;
        customInput.value = 1;
      }

      if (val < 10) {
        selectContainer.classList.remove('hidden');
        inputContainer.classList.add('hidden');
        select.value = val;
      } else {
        selectContainer.classList.add('hidden');
        inputContainer.classList.remove('hidden');
        select.value = '10+';
      }

      if (originalInput) {
        originalInput.value = val;
        originalInput.dispatchEvent(new Event('input', { bubbles: true }));
        originalInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
  });
})();
